export default __webpack_public_path__ + "static/media/image15.1140f94f.jpg";